import React, { useEffect, useState } from "react";
import {
    PaymentElement,
    LinkAuthenticationElement,
    useStripe,
    useElements
} from "@stripe/react-stripe-js";
import CartSuccess from "./CartSuccess";
import CartNotSuccess from "./CartNotSuccess";
import CartInprogress from "./CartInprogress";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import globalContext from '../../context/context'
import { useContext } from "react";
import axios from "axios";

export default function CheckoutForm({preClientSecret = ''}) {
    const stripe = useStripe();
    const elements = useElements();

    const { t } = useTranslation();
    const { contextData: { orderId }, resetCart } = useContext(globalContext);

    const [email, setEmail] = useState('');
    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!stripe) {
            return;
        }

        const clientSecret = new URLSearchParams(window.location.search).get(
            "payment_intent_client_secret"
        );

        if (!clientSecret&&!message) {
            return;
        }

        stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
            switch (paymentIntent.status) {
                case "succeeded":
                    setMessage({
                        text: "Payment succeeded!",
                        status: "success"
                    });
                    if (orderId && clientSecret) {
                        axios.patch(`/api/custom/payments?orderId=${orderId}&clientSecret=${clientSecret}`)
                            .then((res) => {                
                                resetCart()
                            }).catch(err => console.log(err))
                    }
                    break;
                case "processing":
                    setMessage({
                        text: "Your payment is processing.",
                        status: "inprogress"
                    });
                    break;
                case "requires_payment_method":
                    setMessage({
                        text: "Your payment was not successful, please try again.",
                        status: "error"
                    });
                    if (orderId && clientSecret) {
                        axios.patch(`/api/custom/payments?orderId=${orderId}&clientSecret=${clientSecret}`)
                            .catch(err => console.log(err))
                    }
                    break;
                default:
                    setMessage({
                        text: "Something went wrong.",
                        status: "error"
                    });
                    if (orderId && clientSecret) {
                        axios.patch(`/api/custom/payments?orderId=${orderId}&clientSecret=${clientSecret}`)
                            .catch(err => console.log(err))
                    }
                    break;
            }
        });
    }, [stripe]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js hasn't yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        setIsLoading(true);

        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                // Make sure to change this to your payment completion page
                return_url: "https://myplusair.com/cart",
                // return_url: "http://localhost:3000/cart",
            },
        });

        // This point will only be reached if there is an immediate error when
        // confirming the payment. Otherwise, your customer will be redirected to
        // your `return_url`. For some payment methods like iDEAL, your customer will
        // be redirected to an intermediate site first to authorize the payment, then
        // redirected to the `return_url`.

        console.log('error', error);
        if(error?.type) {
            setMessage({
                text: error.message,
                status: "error"
            })
        } else {
            setMessage({
                text: "An unexpected error occurred.",
                status: "error"
            })
        }

        setIsLoading(false);
    };

    const paymentElementOptions = {
        layout: "tabs"
    }

    return (
        <form id="payment-form" onSubmit={handleSubmit}>
            {message
                ? <>
                {message?.status==='success'&&<CartSuccess />}
                {message?.status==='error'&&<CartNotSuccess clientSecret={preClientSecret} message={message.text} />}
                {message?.status==='inprogress'&&<CartInprogress />}
                </>
                : <>
                    <LinkAuthenticationElement
                        id="link-authentication-element"
                        onChange={(e) => setEmail(e?.target?.value)}
                    />
                    <PaymentElement id="payment-element" options={paymentElementOptions} />
                    <Box style={{textAlign: 'right'}}>
                    <button style={{
                        outline: 0,
                        border: 0,
                        margin: '10px 0 0 0',
                        borderRadius: 0,
                        cursor: 'pointer',
                        textTransform: 'uppercase',
                        minWidth: '64px',
                        padding: '6px 16px',
                        transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                        color: '#fff',
                        backgroundColor: '#1976d2',
                        boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
                        backgroundColor: 'rgba(235,64,129,1)',
                    }} disabled={isLoading || !stripe || !elements} id="submit">
                        <span id="button-text">
                            {isLoading ? <div className="spinner" id="spinner"></div> : t('cart.payNow')}
                        </span>
                    </button>
                    </Box>
                </>}
        </form>
    );
}